"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaystePayableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
exports.WaystePayableSchema = {
    name: 'wayste-payable',
    alias: 'Wayste Payable',
    shortName: 'Bill',
    applications: ['wayste'],
    disabled: true,
    returnType: {
        wayste: transport_types_1.Invoice.WaystePayableTransport,
    },
    searchableAttributes: [
        {
            field: 'invoiceDetails.orderNumber',
            alias: 'Order Number',
            shortName: 'orderNumber',
            searchableByDefault: true,
        },
        // {
        //   field: 'vendorName',
        //   alias: 'Account Number',
        //   shortName: 'Account Number',
        //   searchableByDefault: false,
        // },
    ],
    filterableAttributes: [
        {
            type: 'NUMBER',
            field: 'invoiceDetails.total',
            alias: 'Total',
            shortName: 'amount',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.payments.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [],
};
//# sourceMappingURL=wayste-payable.js.map